import React from 'react'
import ReactDOM from 'react-dom'
import throttle from 'lodash/throttle'
import fr from 'react-intl/locale-data/fr'
import { addLocaleData, IntlProvider } from 'react-intl'
import 'moment/locale/fr';
import moment from 'moment'
import App from './App'
import { themeLight2 } from '@medeo/themes'
import { configureStore, history } from './store'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { injectGlobal, ThemeProvider } from 'styled-components'
import { loadState, saveState } from './utils/localStorage'
import flattenMessages from './utils/flattenMessages'
import messages from './messages'
console.log(themeLight2)
moment.locale('fr')
injectGlobal`
  // place the font-faces here
  body {
    margin: 0; 
    background: ${themeLight2.palette.colorLight2};
  }
  
  
  #root {
    font-family: MontSerrat, sans-serif;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
`

addLocaleData([...fr])
const locale = 'fr-FR'

const initialState = loadState()
const store = configureStore(initialState)

store.subscribe(
  throttle(() => {
    saveState({
      user:
        store.getState().user.stayConnected === true
          ? store.getState().user
          : {}
    })
  }, 1000)
)

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider messages={flattenMessages(messages[locale])} locale={locale}>
      <ThemeProvider theme={themeLight2}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </ThemeProvider>
    </IntlProvider>
  </Provider>,
  document.getElementById('root')
)

//               </IntlProvider>



// WEBPACK FOOTER //
// ./src/index.js